import { Component, Input } from '@angular/core';
import { AlertType, AlertTypeBase } from '../alert-message/alert-message.component';

@Component({
    selector: 'lib-alert',
    templateUrl: './alert.component.html',
    styleUrls: ['./alert.component.scss'],
    standalone: false
})
export class AlertComponent {
  @Input() show: boolean = false;
  @Input() type: AlertType = AlertTypeBase.Success;
  @Input() dismissible: boolean = true;
  @Input() centerContent: boolean = false;
  @Input() showIcon: boolean = false;

  hide(): void {
    this.show = false;
  }
}
